<script>
  import Button from '@components/button.svelte'
  import { Search, LoaderCircle, Ellipsis, DatabaseZap, Database, Building2, Globe, Maximize2, Highlighter } from 'lucide-svelte'
  import searchState from '@state/global-search-state.svelte.js'

  // Props
  let { list, onToggle } = $props()

  // Reactive state
  let inputRef = $state(null)

  // Functions
  function toggleSetting(key) {
    searchState[key] = !searchState[key]
    onToggle?.()
  }

  function settingClass(key) {
    return searchState[key] ? "border-teal-500 text-teal-500" : "border-stone-200 text-stone-400"
  }

  // Exported functions
  export function focus() {
    inputRef?.focus()
  }

  export function blur() {
    inputRef?.blur()
  }
</script>

<!-- The search input container -->
<div class="flex items-center justify-between px-4 py-4 bg-transparent border-b border-stone-200/60 rounded-t-xl pr-6">

  <!-- The search icon -->
  <Search size={22} strokeWidth={1.5} class="text-stone-400 mr-2" />

  <!-- The search input -->
  <input bind:this={inputRef} bind:value={list.query}
    class="flex-1 bg-transparent border-none focus:outline-none focus:ring-0 text-[15px] placeholder:text-[15px] placeholder:text-stone-400/80"
    placeholder="Rechercher tout..."
    onkeydown={list.onkeydown} />


    <!-- Action button/tags -->
    <div class="flex items-center gap-3">

      <!-- The loading or typing indicator -->
    {#if list.loading}
      <LoaderCircle size={22} strokeWidth={1.5} class="text-teal-400 animate-spin" />
    {:else if list.typing}
      <Ellipsis size={22} strokeWidth={1.5} class="text-teal-400 animate-pulse" />
    {/if}

    <!-- Highlight toggle button -->
    <Button naked Icon={Highlighter} hint={`Surligner les correspondances: ${searchState.highlight ? 'Oui' : 'Non'}`} iconSize={16} onclick={() => toggleSetting("highlight")} class={settingClass("highlight")} />

    <!-- Mode toggle button -->
    <Button naked Icon={DatabaseZap} hint={`Mode Algolia: ${searchState.algoliaOnly ? 'Oui' : 'Non'}`} iconSize={16} onclick={() => toggleSetting("algoliaOnly")} class={settingClass("algoliaOnly")} />

    <!-- Clinic scoped/global toggle button -->
    <Button naked Icon={Globe} hint={`Afficher pour toutes les cliniques: ${searchState.globalScope ? 'Oui' : 'Non'}`} iconSize={16} onclick={() => toggleSetting("globalScope")} class={settingClass("globalScope")} />

    <!-- Full screen toggle button -->
    <Button naked Icon={Maximize2} hint={`Plein écran: ${searchState.fullScreen ? 'Oui' : 'Non'}`} iconSize={16} onclick={() => toggleSetting("fullScreen")} class={settingClass("fullScreen")} />

  </div>

</div>
